import React, { Fragment, useEffect, useState } from "react"
import { Modal } from 'react-bootstrap'

import { formatDate, formatMoney } from 'helpers/helpers'
import { httpOk, GET } from 'helpers/api'

const PERIODS = [7, 14, 30]

// Воронка «пробивает чеки и платит»: каждая ступень — подмножество предыдущей.
// Демо-точки (is_internal) сервер не считает.
function ModalPosActivityFunnel({ show, onHide }) {
	const [data, setData] = useState(null)
	const [days, setDays] = useState(7)
	const [opened, setOpened] = useState(null)

	async function getData(nextDays = days) {
		const response = await GET('/admin/pos/activity-funnel', { days: nextDays }, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	function changeDays(nextDays) {
		setDays(nextDays)
		setOpened(null)
		getData(nextDays)
	}

	useEffect(() => {
		if (show) {
			setOpened(null)
			getData()
		} else {
			setData(null)
		}
	}, [show]) // eslint-disable-line react-hooks/exhaustive-deps

	const month = data?.month ?? ''
	const prevMonth = data?.prev_month ?? ''
	const labels = {
		status_active: 'Статус «Активный» (не заблокированы)',
		cheques_30: 'Есть чеки за 30 дней',
		cheques_period: `Есть чеки за ${days} дней`,
		charged: `…и за ${month} было начисление`,
		paid: `…и ${month} оплачен полностью`,
		paid_both: `…и ${prevMonth} тоже оплачен полностью`,
		debtors: 'Должники: чеки есть, месяц оплачен не полностью',
		free_period: 'Бесплатный период',
		new_no_charge: 'Новые в этом месяце, начисления ещё не было',
		no_charge_other: 'Без начисления (тариф 0 и прочее)',
	}

	const stages = data?.stages ?? []
	const side = data?.side ?? []
	const base = stages[0]?.total ?? 0

	function renderRows(groups, highlightKey) {
		return groups.map(group => {
			const isOpened = opened === group.key
			const percent = base ? group.total * 100 / base : 0
			return (
				<Fragment key={group.key}>
					<tr style={{ cursor: 'pointer' }}
						className={group.key === highlightKey ? 'fw-bold' : ''}
						onClick={() => setOpened(isOpened ? null : group.key)}>
						<td>
							<i className={`uil ${isOpened ? 'uil-angle-down' : 'uil-angle-right'} me-1`}></i>
							{labels[group.key]}
						</td>
						<td className="text-end">{group.total}</td>
						<td>
							<div className="d-flex align-items-center gap-2">
								<div className="progress flex-grow-1" style={{ height: 8 }}>
									<div className={`progress-bar ${group.key === highlightKey ? 'bg-success' : ''}`}
										style={{ width: `${percent}%` }}></div>
								</div>
								<span className="text-muted text-end" style={{ width: 48 }}>
									{percent.toFixed(0)}%
								</span>
							</div>
						</td>
					</tr>
					{isOpened && group.poses.map(pos => (
						<tr key={`${group.key}-${pos.id}`} style={{ background: 'var(--dark-surface-2, #f8f9fa)' }}>
							<td colSpan={3}>
								<div className="d-flex gap-2">
									<span className="text-muted">#{pos.id}</span>
									<span className="text-nowrap">{pos.login}</span>
									<span>{pos.name}</span>
									<span className="text-muted text-nowrap ms-auto">
										{pos.debt > 0 && <span className="text-danger me-2">долг {formatMoney(pos.debt)}</span>}
										{pos.tariff > 0 && <span className="me-2">тариф {formatMoney(pos.tariff)}</span>}
										{pos.last_cheque_date ? `чек ${formatDate(pos.last_cheque_date)}` : 'чеков нет'}
									</span>
								</div>
							</td>
						</tr>
					))}
				</Fragment>
			)
		})
	}

	return (
		<Modal show={show} animation={false} centered size="lg"
			onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Активные и платящие точки</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex flex-wrap align-items-center gap-2 mb-2" style={{ fontSize: 13 }}>
					<div className="btn-group btn-group-sm">
						{PERIODS.map(item => (
							<button key={item} type="button"
								className={`btn ${days === item ? 'btn-primary' : 'btn-outline-primary'}`}
								onClick={() => changeDays(item)}>
								{item} дней
							</button>
						))}
					</div>
					{data &&
						<span className="ms-auto">
							Оплачено за {month}: <b>{formatMoney(data.mrr_paid)}</b>
							{data.debt_total > 0 && <span className="text-danger ms-2">· долг {formatMoney(data.debt_total)}</span>}
						</span>
					}
				</div>

				{/* высота фиксированная: раскрытый список не должен двигать модалку */}
				<div className="table-responsive" style={{ height: 480, maxHeight: '60vh', overflowY: 'auto' }}>
					<table className="table table-bordered table-hover mb-0" style={{ fontSize: 13 }}>
						<thead style={{ position: 'sticky', top: 0, background: 'var(--dark-surface, #fff)', zIndex: 1 }}>
							<tr>
								<th>Критерий</th>
								<th className="text-end" style={{ width: 80 }}>Точек</th>
								<th style={{ width: 200 }}>От активных</th>
							</tr>
						</thead>
						<tbody>
							{renderRows(stages, 'paid')}
							{side.length > 0 &&
								<tr>
									<td colSpan={3} className="text-muted fw-semibold" style={{ background: 'var(--dark-surface-3, #f1f3f5)' }}>
										Пробивают чеки, но не вошли в «оплачен полностью»
									</td>
								</tr>
							}
							{renderRows(side)}
						</tbody>
					</table>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default ModalPosActivityFunnel
